<div class="elements-container">
  <div class="elements-list">
    @for (element of elements$ | async; track element.id) {
      @if (element.isDivider) {
        <div class="divider-section">
          <div class="divider-label">
            {{ element.label | translate }}
          </div>
        </div>
      } @else {
        @if (!!element.staffOnly) {
          <gb-staff-only-options>
            <ng-container [ngTemplateOutlet]="elementBlock" [ngTemplateOutletContext]="{ $implicit: element }">
            </ng-container
          ></gb-staff-only-options>
        } @else {
          <ng-container [ngTemplateOutlet]="elementBlock" [ngTemplateOutletContext]="{ $implicit: element }">
          </ng-container>
        }
      }
    }
  </div>
</div>

@let auctionLoaded = auctionLoaded$ | async;

<ng-template #elementBlock let-element>
  <div
    class="element-block"
    matRipple
    [matRippleColor]="'rgba(0, 0, 0, 0.1)'"
    [draggable]="isLoaded(element.id)"
    (click)="onElementClick(element, auctionLoaded)"
    (dragstart)="onElementDragStart($event, element)"
    [attr.data-element-id]="element.id"
    [matTooltip]="element.description | translate"
    [matTooltipShowDelay]="1000"
  >
    <div class="element-block-inner">
      <div class="element-icon">
        @if (isLoaded(element.id)) {
          <gb-icon [icon]="element.icon" [library]="element.library" height="18px"></gb-icon>
        } @else {
          <mat-progress-spinner mode="indeterminate" [diameter]="18"></mat-progress-spinner>
        }
      </div>

      <div class="element-text-container">
        <div class="element-title">
          {{ element.label | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
